const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
const TIMEOUT_SEC = 6;
const RESULTS_PER_PAGE = 10;
const API_KEY = '7c9eae49-66a5-4040-9cdc-b380993ff7f6';

export { API_URL, API_KEY, TIMEOUT_SEC, RESULTS_PER_PAGE };